export function goTop(selector = '.footer__gotop') {
  document.querySelectorAll(selector).forEach((btn) => {
    btn.addEventListener('click', () => {
      window.scroll(0, 0);
    });
  });
}
